<template>
  <div class="main-container">
    <div class="wrapper">
      <div>
        <section class="main-section">
          <div class="error-message">
            <p>
              システムエラーが発生しました。<br />システム管理者にお問い合わせください
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script></script>
